import { createRouter, createWebHistory } from "vue-router";
import HFO_MA_001 from "@/pages/HFO_MA_001.vue";
import HFOSP001 from "@/pages/HFO_SP_001.vue";
import HFOCP001 from "@/pages/HFO_CP_001.vue";
import HFOCO003 from "@/pages/HFO_CO_003.vue";
import HFOCO004 from "@/pages/HFO_CO_004.vue";
import HFOBI001 from "@/pages/HFO_BI_001.vue";
import HFOBI001KBPRM from "@/pages/HFO_BI_001_KBPRM.vue";
import HFOBI002 from "@/pages/HFO_BI_002.vue";
import HFOBI002KBPRM from "@/pages/HFO_BI_002_KBPRM.vue";
import HFOBI002NHPRM from "@/pages/HFO_BI_002_NHPRM.vue";
import HFOBI003 from "@/pages/HFO_BI_003.vue";
import HFOMS001 from "@/pages/HFO_MS_001.vue";
import HFOPR001 from "@/pages/HFO_PR_001.vue";
import HFOPR003 from "@/pages/HFO_PR_003.vue";
import HFOCS001 from "@/pages/HFO_CS_001.vue";
import HFOCS002 from "@/pages/HFO_CS_002.vue";
import HFOCS003 from "@/pages/HFO_CS_003.vue";
import HFOCS004 from "@/pages/HFO_CS_004.vue";
import HFOLO001 from "@/pages/HFO_LO_001.vue";
import HFOLO001POP from "@/pages/HFO_LO_001_POP.vue";
import HFOLO001FOODCON from "@/pages/HFO_LO_001_FOODCON.vue";
import HFOBGFC001 from "@/pages/HFO_BG_FC_001.vue";
import HFOSH001 from "@/pages/HFO_SH_001.vue";
import HFOLO002 from "@/pages/HFO_LO_002.vue";
import HFOLO005 from "@/pages/HFO_LO_005.vue";
import HFOMB003 from "@/pages/HFO_MB_003.vue";
import HFOMB004SNS from "@/pages/HFO_MB_004_SNS.vue";
import HFOMB004 from "@/pages/HFO_MB_004.vue";
import HFOMB005 from "@/pages/HFO_MB_005.vue";
import HFOMP003 from "@/pages/HFO_MP_003.vue";
import HFOMP004 from "@/pages/HFO_MP_004.vue";
import HFOMP005 from "@/pages/HFO_MP_005.vue";
import HFOMP006 from "@/pages/HFO_MP_006.vue";
import HFOMP007 from "@/pages/HFO_MP_007.vue";
import HFOMP008 from "@/pages/HFO_MP_008.vue";
import HFOHI001 from "@/pages/HFO_HI_001.vue";
import HFOHI002 from "@/pages/HFO_HI_002.vue";
import HFOHI004 from "@/pages/HFO_HI_004.vue";
import HFOER001 from "@/pages/HFO_ER_001.vue";
import { isAuthenticated } from "@/lib/UserInfo";
import { applyRouteMeta } from "@/lib/Seo";
import { SEO_BY_PATH } from "@/router/seo";

const routes = [
	{
		path: "/",
		component: HFO_MA_001,
		meta: { layoutClass: "main" },
	},
	{
		path: "/HFO_SP_001",
		component: HFOSP001,
	},
	{
		path: "/HFO_CP_001",
		component: HFOCP001,
	},
	{
		path: "/HFO_CO_003",
		component: HFOCO003,
	},
	{
		path: "/HFO_CO_004",
		component: HFOCO004,
	},
	{
		path: "/HFO_BI_001",
		name: "HFO_BI_001",
		component: HFOBI001,
		meta: { keepAlive: true },
	},
	{
		path: "/HFO_BI_001_KBPRM",
		name: "HFO_BI_001_KBPRM",
		component: HFOBI001KBPRM,
		meta: { keepAlive: true },
	},
	{
		name: "HFO_BI_002",
		path: "/HFO_BI_002/:brandUuid?",
		component: HFOBI002,
	},
	{
		name: "HFO_BI_002_KBPRM",
		path: "/HFO_BI_002_KBPRM/:brandUuid?",
		component: HFOBI002KBPRM,
	},
	{
		name: "HFO_BI_002_NHPRM",
		path: "/HFO_BI_002_NHPRM/:brandUuid?",
		component: HFOBI002NHPRM,
		meta: { hideHeaderFooter: true },
	},
	{
		path: "/HFO_BI_003",
		component: HFOBI003,
	},
	{
		path: "/HFO_MS_001",
		component: HFOMS001,
	},
	{
		path: "/HFO_PR_001",
		component: HFOPR001,
	},
	{
		name: "HFO_PR_003",
		path: "/HFO_PR_003/:eventUuid?",
		component: HFOPR003,
	},
	{
		path: "/HFO_CS_001",
		component: HFOCS001,
	},
	{
		path: "/HFO_CS_002/:noticeSeq?",
		component: HFOCS002,
	},
	{
		path: "/HFO_CS_003",
		component: HFOCS003,
	},
	{
		path: "/HFO_CS_004",
		component: HFOCS004,
	},
	{
		name: "login",
		path: "/HFO_LO_001",
		component: HFOLO001,
	},
	{
		name: "loginPopup",
		path: "/HFO_LO_001_POP",
		component: HFOLO001POP,
		meta: { hideHeaderFooter: true },
	},
	{
		name: "loginFoodcon",
		path: "/HFO_LO_001_FOODCON",
		component: HFOLO001FOODCON,
		meta: { hideHeaderFooter: true },
	},
	{
		name: "fixedZoneFoodcon",
		path: "/HFO_BG_FC_001",
		component: HFOBGFC001,
		meta: { hideHeaderFooter: true },
	},
	{
		name: "shortUrlBridge",
		path: "/HFO_SH_001/:shortKey?",
		component: HFOSH001,
		meta: { hideHeaderFooter: true },
	},
	{
		path: "/HFO_LO_002",
		component: HFOLO002,
	},
	{
		path: "/HFO_LO_005",
		component: HFOLO005,
	},
	{
		path: "/HFO_MB_003",
		component: HFOMB003,
		meta: { hideHeaderFooter: true },
	},
	{
		path: "/HFO_MB_004_SNS",
		component: HFOMB004SNS,
		meta: { hideHeaderFooter: true },
	},
	{
		path: "/HFO_MB_004",
		component: HFOMB004,
	},
	{
		path: "/HFO_MB_005",
		component: HFOMB005,
		meta: { hideHeaderFooter: true },
	},
	{
		path: "/HFO_MP_003",
		component: HFOMP003,
	},
	{
		path: "/HFO_MP_004",
		component: HFOMP004,
	},
	{
		name: "myPage",
		path: "/HFO_MP_005",
		component: HFOMP005,
		meta: { requiresAuth: true }, // 로그인이 필요한 페이지인 경우 추가
	},
	{
		path: "/HFO_MP_006",
		component: HFOMP006,
	},
	{
		path: "/HFO_MP_007",
		component: HFOMP007,
	},
	{
		path: "/HFO_MP_008",
		component: HFOMP008,
	},
	{
		path: "/HFO_HI_001",
		component: HFOHI001,
	},
	{
		path: "/HFO_HI_002",
		component: HFOHI002,
	},
	{
		path: "/HFO_HI_004",
		component: HFOHI004,
	},
	{
		path: "/HFO_ER_001",
		component: HFOER001,
	},
];

// SEO: 경로별 title/description 을 meta.seo 로 붙인다. 목록에 없는 경로(로그인·회원·마이페이지·팝업·테스트)는 noindex.
routes.forEach((route) => {
	const key = route.path.replace(/\/:.*$/, "");
	const seo = SEO_BY_PATH[key] || { noindex: true };
	route.meta = { ...(route.meta || {}), seo };
});
// 정의되지 않은 경로는 에러 페이지로 보내고 noindex 처리한다 (SPA 는 서버가 200 을 주므로 소프트 404 방지용).
routes.push({
	name: "notFound",
	path: "/:pathMatch(.*)*",
	component: HFOER001,
	meta: { seo: { noindex: true, title: "페이지를 찾을 수 없습니다" } },
});
const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior(to, from, savedPosition) {
		// 뒤로가기 등 savedPosition이 있으면 그 지점으로
		if (savedPosition) return savedPosition;
		// keepAlive 페이지는 스크롤 유지
		if (to.meta.keepAlive) return false;
		return { left: 0, top: 0 };
	},
});

router.beforeEach((to, from, next) => {
	const allmenuBtn = document.querySelector(".header");
	if (allmenuBtn) {
		allmenuBtn.classList.remove("open");
	}

	// 로그인이 필요한 페이지로 이동하는 경우 로그인 페이지로 이동 후 리다이렉트 처리
	if (to.meta?.requiresAuth && !isAuthenticated()) {
		next({ name: "login", query: { redirect: to.fullPath } });
	}

	next();
});

// 페이지 이동 후 page_view 전송
// 이유: SPA 내부 라우트 이동은 기본 브라우저 페이지뷰가 발생하지 않으므로
// router.afterEach에서 dataLayer에 명시적 'page_view' 이벤트를 전송합니다.
// 주의: GTM/GA4에서 자동 page_view(send_page_view)가 활성화되어 있으면 중복 집계가 발생하므로
// 배포 전 GTM 설정에서 자동 page_view를 비활성화하는 것을 권장합니다.
function _sendPageView(params = {}) {
	try {
		const { page_path = '', page_title = '', page_location = '', extras = {} } = params;

		if (typeof window !== 'undefined' && Array.isArray(window.dataLayer)) {
			const payload = Object.assign({
				event: 'page_view',
				page_path,
				page_title,
				page_location,
				page_host: (window.location && window.location.hostname) || '',
			}, extras);
			window.dataLayer.push(payload);
		}

		if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
			// GA4에 직접 전송(옵션). GTM을 통해 연결된 경우에는 dataLayer로만 처리해도 무방합니다.
			window.gtag('event', 'page_view', {
				page_path,
				page_title,
				page_location,
				page_host: (window.location && window.location.hostname) || '',
			});
		}
	} catch (e) {
		// 안전상 아무 작업도 하지 않음 (운영환경에서 로그를 남기지 않음)
	}
}

router.afterEach((to) => {
	applyRouteMeta(to);
	const page_path = to.fullPath || (window.location.pathname + window.location.search);
	const page_title = document.title || (to.name || '');
	const page_location = (typeof window !== 'undefined' && window.location && window.location.href) ? window.location.href : '';

	// 페이지명 매핑 (Looker Studio에서 CASE 처리 대신 page_name을 직접 사용 가능)
	const mapPageName = (path) => {
		if (!path) return '기타';
		if (path === '/' || path === '/index.html' || /^\/HFO_MA_001/.test(path)) return '메인페이지';
		if (/^\/HFO_SP_001/.test(path)) return '쇼핑';
		if (/^\/HFO_CP_001/.test(path)) return '쿠폰소개';
		if (/^\/HFO_CO_003/.test(path) || /^\/HFO_CO_004/.test(path)) return '약관';
		if (/^\/HFO_BI_001/.test(path)) return '제휴브랜드';
		if (/^\/HFO_BI_002/.test(path)) return '제휴브랜드 상세';
		if (/^\/HFO_BI_003/.test(path)) return '제휴문의';
		if (/^\/HFO_MS_001/.test(path)) return '매장검색';
		if (/^\/HFO_PR_001/.test(path)) return '프로모션';
		if (/^\/HFO_PR_003/.test(path)) return '프로모션 상세';
		if (/^\/HFO_CS_001/.test(path)) return '공지사항';
		if (/^\/HFO_CS_002/.test(path)) return '공지사항 상세';
		if (/^\/HFO_CS_003/.test(path)) return 'FAQ';
		if (/^\/HFO_CS_004/.test(path)) return '1대1문의';
		if (/^\/HFO_LO_001/.test(path)) return '로그인';
		if (/^\/HFO_LO_002/.test(path)) return '아이디 찾기';
		if (/^\/HFO_LO_005/.test(path)) return '비밀번호 찾기';
		if (/^\/HFO_MB_003/.test(path) || /^\/HFO_MB_004_SNS/.test(path) || /^\/HFO_MB_004/.test(path) || /^\/HFO_MB_005/.test(path)) return '회원가입';
		if (/^\/HFO_HI_001/.test(path)) return '브랜드소개';
		if (/^\/HFO_HI_002/.test(path)) return '청구할인 혜택 정리';
		if (/^\/HFO_HI_004/.test(path)) return '기업소개';
		if (/^\/HFO_ER_001/.test(path)) return '에러페이지';
		return '기타';
	};

	const page_name = mapPageName(page_path);
	const extras = (to.path === '/HFO_PR_001') ? { page_section: 'HFO_PR_001', page_name } : { page_name };

	_sendPageView({ page_path, page_title, page_location, extras });
});

export default router;
